export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=1ade23e8&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Divisions/index.vue?vue&type=template&id=1ade23e8&scoped=true
// module id = 2533
// module chunks = 31